import { render, staticRenderFns } from "./informationIcon.vue?vue&type=template&id=37a7fe05"
import script from "./informationIcon.vue?vue&type=script&lang=js"
export * from "./informationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports